import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventHandler } from '../../../services/eventHandler';
import { AppSession } from '../../../values/appSession';
import { ContentHelper } from '../../../values/contentHelper';
import { BaseComponent } from '../../base-component/baseCmp';
import { IMetadataResponse } from '../models/iMetadata';

@Component({
  moduleId: module.id,
  selector: 'app-emulate-metadata-cmp',
  templateUrl: './emulateMetadataCmp.html'
})
export class EmulateMetadataComponent extends BaseComponent implements OnInit {
  showLoader: boolean = false;
  pfLoaderError: boolean = false;
  pfLoaderErrorText: string = '';
  emulatedMetadataResponse: IMetadataResponse;
  @ViewChild('pfContainerElement', { static: false }) public pfElement: ElementRef;
  private el: HTMLElement;

  constructor(
    private _eventHandler: EventHandler,
    private _route: ActivatedRoute,
    @Inject(AppSession)
    private _appSession: AppSession,
    @Inject(ContentHelper)
    private _contentHelper: ContentHelper
  ) {
    super(_route, _eventHandler, _appSession, _contentHelper, 'EmulateUserComponent');
  }

  ngOnInit(): void {
    this.emulatedMetadataResponse = this._appSession.emulatedMetadataResponse;
    this.getFindCareLoader();
  }

  getFindCareLoader() {
    this.showLoader = true;
    this.loadPfElement(this.emulatedMetadataResponse.metadata);
  }

  loadExternalScript(url: string, windowType?: string) {
    return new Promise<void>((res, rej) => {
      if (typeof window[windowType as string] === 'undefined') {
        const body = document.getElementsByTagName('body')[0];
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.onload = () => {
          res();
        };
        script.onerror = () => {
          console.error('Error loading ' + windowType + ' script library');
          rej();
        };
        script.src = url;
        body.appendChild(script);
      } else {
        res();
      }
    });
  }

  loadPfElement(metadata: string) {
    this.loadExternalScript(this.emulatedMetadataResponse.fcLoader, 'pfLoader').then(
      () => {
        setTimeout(() => {
          this.createCustomPfElement(metadata);
        }, 100);
      },
      (error) => {
        console.log(`pf-loader.js call failed: ${JSON.stringify(error)}`);
      }
    );
  }

  createCustomPfElement(metadata: string) {
    this.el = document.createElement('pf-element');
    this.el.setAttribute('metadata', metadata);
    this.el.addEventListener('onPfAppError', (e: unknown) => {
      this.loadError(e);
    });
    this.el.addEventListener('onPfAppLoadSuccess', (e: unknown) => {
      this.loadSuccess(e);
    });
    this.el.addEventListener('onPfAppLoadStart', (e: unknown) => {
      this.loadStart(e);
    });
    this.el.addEventListener('onPfAppCommand', (event: any) => {
      if (event && event?.detail && event.detail.target) console.log(event.detail.target, event.detail.object);
    });
    this.pfElement.nativeElement.appendChild(this.el);
  }

  loadStart(e: unknown) {
    console.log(e);
    this.showLoader = true;
  }

  loadSuccess(e: unknown) {
    this.showLoader = false;
    console.log(e);
  }

  loadError(_e: unknown) {
    console.log(_e);
    const e = _e as { detail: { type: string } };
    if (e && e.detail && e.detail.type && e.detail.type === 'PF_APP_LOAD_ERR') {
      this.pfLoaderErrorText = `Error thrown from Find Care: ${JSON.stringify(_e)}`;
      this.pfLoaderError = true;
    }
    this.showLoader = false;
  }
}
